import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CustomPageSizeControllerComponent } from './custom-page-size-controller.component';
import { SelectModule, ButtonModule } from "@bssh/comp-lib";

@NgModule({
  declarations: [CustomPageSizeControllerComponent],
  imports: [
    CommonModule,
    ButtonModule,
    SelectModule
  ],
  exports: [CustomPageSizeControllerComponent]
})
export class CustomPageSizeControllerModule { }
